import OrcamentoService from '@/services/OrcamentoService'

export const orcamento = {
  namespaced: true,
  actions: {    
    buscarFinancasEixoSocial ({ dispatch } ) {
      return OrcamentoService.buscarFinancasEixoSocial()
        .then(
          response => {
            return response;
          },
          error => {
            console.error(error);
          }
        );
    },

  },
  state: {},
  mutations: {},
}
